<template>
  <div class="blog-layout">
    <NavBar />
    <main class="blog-main">
      <router-view />
    </main>
    <footer class="blog-footer">
      <p class="copyright">&copy; 2026 HwBlogs</p>
      <div class="icp-info">
        <a href="https://beian.miit.gov.cn/" target="_blank" rel="noopener noreferrer">豫ICP备2026032920号-1</a>
        <span class="separator">·</span>
        <a href="http://www.beian.gov.cn/" target="_blank" rel="noopener noreferrer">豫公网安备41070202001853号</a>
      </div>
    </footer>
  </div>
</template>

<script setup>
import NavBar from '@/components/blog/NavBar.vue'
</script>

<style scoped>
.blog-layout {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}

.blog-main {
  flex: 1;
  max-width: 900px;
  width: 100%;
  margin: 0 auto;
  padding: 40px 20px;
}

.blog-footer {
  border-top: 1px solid var(--border);
  padding: 24px 20px;
  text-align: center;
  color: var(--text-secondary);
  font-size: 14px;
}

.blog-footer p {
  margin: 0;
}

.copyright {
  margin-bottom: 8px;
}

.icp-info {
  font-size: 12px;
  color: var(--text-secondary);
}

.icp-info a {
  color: var(--text-secondary);
  text-decoration: none;
}

.icp-info a:hover {
  color: var(--text-primary);
  text-decoration: underline;
}

.separator {
  margin: 0 8px;
  color: var(--text-secondary);
}
</style>
